<template>
  <section>
    <nav class="columns">
      <div class="column">
        <b-field grouped group-multiline>
          <b-field>
            <b-select
              v-model="selectedArea"
              :loading="loadingAreas"
              :placeholder="$t('message.please_select') + $t('attributes.area')"
              @input="onSelectArea"
            >
              <option value="">
                {{ $t('attributes.all_area') }}
              </option>
              <option
                v-for="option in areas"
                :value="option"
                :key="option.code"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <b-field>
            <b-select
              v-model="selectedCatalog"
              :loading="loadingAreas"
              :disabled="catalogs.length <= 0"
              :placeholder="
                $t('message.please_select') + $t('attributes.catalog')
              "
              @input="onSelectCatalog"
            >
              <option value="">全部類別</option>
              <option
                v-for="option in catalogs"
                :value="option"
                :key="option.catalog_no"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>

          <b-field>
            <p class="control">
              <span class="button is-static">
                {{ $t('attributes.activation_status') }}
              </span>
            </p>
            <b-select v-model="filterStatus" @input="onFilterStatus">
              <option value="">{{ $t('attributes.all') }}</option>
              <option value="true">{{ $t('attributes.shelve_on') }}</option>
              <option value="false">{{ $t('attributes.shelve_off') }}</option>
            </b-select>
          </b-field>

          <b-field>
            <p class="control">
              <span class="button is-static">
                {{ $t('attributes.is_promote') }}
              </span>
            </p>
            <b-select v-model="isHome" @input="onFilterStatus">
              <option value="">{{ $t('attributes.all') }}</option>
              <option value="true">{{ $t('attributes.yes') }}</option>
              <option value="false">{{ $t('attributes.no') }}</option>
            </b-select>
          </b-field>

          <b-field>
            <b-select v-model="showExpired" @input="onFilterStatus">
              <option value="true">
                {{ $t('attributes.display_expired') }}
              </option>
              <option value="false">
                {{ $t('attributes.not_display_expired') }}
              </option>
            </b-select>
          </b-field>

          <b-field>
            <b-datepicker
              :placeholder="
                $t('message.please_select') + $t('attributes.departure_date')
              "
              v-model="selectedDates"
              range
              @input="onSelectedDates"
            >
              <button class="button is-danger" @click="onClearDates">
                <b-icon icon="close"></b-icon>
                <span>Clear</span>
              </button>
            </b-datepicker>
          </b-field>

          <b-field>
            <b-input
              v-model="searchCode"
              :placeholder="
                $t('attributes.search') + $t('attributes.group_code')
              "
              type="search"
              icon="magnify"
              @input="onFilter"
            ></b-input>
          </b-field>
          <b-field>
            <b-input
              v-model="searchName"
              :placeholder="$t('attributes.search') + $t('attributes.name')"
              type="search"
              icon="magnify"
              @input="onFilter"
            ></b-input>
          </b-field>
        </b-field>
      </div>

      <div class="column is-3 is-2-desktop">
        <div class="buttons is-right">
          <b-button
            :loading="sending"
            :disabled="this.selectedItems.length === 0"
            type="is-danger"
            icon-left="delete"
            @click="onDeleteMulti"
          >
            {{ $t('attributes.delete_selected') }}
          </b-button>
        </div>
      </div>
    </nav>

    <b-table
      :data="items"
      :loading="isLoading"
      :hoverable="true"
      :narrowed="true"
      :mobile-cards="true"
      :checked-rows.sync="selectedItems"
      checkable
      paginated
      pagination-position="bottom"
      backend-pagination
      backend-sorting
      :total="total"
      :current-page="parseInt(page)"
      :per-page="perPage"
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      @page-change="onPageChange"
      @sort="onSort"
    >
      <b-table-column
        field="code"
        :label="$t('attributes.group_code')"
        width="160"
        sortable
        centered
        v-slot="props"
      >
        {{ props.row.code }}
      </b-table-column>

      <b-table-column
        field="shelve_on"
        :label="$t('attributes.activation_status')"
        width="75"
        sortable
        centered
        v-slot="props"
      >
        <b-tag
          :type="props.row.shelve_on ? 'is-info' : 'is-danger'"
          size="is-medium"
        >
          {{ shelveStatus(props.row.shelve_on) }}
        </b-tag>
      </b-table-column>

      <b-table-column
        field="days"
        :label="$t('attributes.days')"
        width="85"
        sortable
        numeric
        v-slot="props"
      >
        {{ props.row.days }}
      </b-table-column>

      <b-table-column
        field="departure_date"
        :label="$t('attributes.departure_date')"
        width="110"
        sortable
        v-slot="props"
      >
        {{ formatDate(props.row.departure_date) }}
      </b-table-column>

      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        sortable
        v-slot="props"
      >
        <p v-html="props.row.name"></p>
      </b-table-column>

      <b-table-column
        field="is_home"
        :label="$t('attributes.is_promote')"
        sortable
        centered
        v-slot="props"
      >
        {{ whetherStatus(props.row.is_home) }}
      </b-table-column>

      <b-table-column
        :label="$t('attributes.function')"
        width="75"
        centered
        v-slot="props"
      >
        <b-button
          :loading="sending"
          type="is-danger"
          icon-left="delete"
          @click.prevent.stop="onDelete(props.row.code)"
        >
          {{ $t('attributes.delete') }}
        </b-button>
      </b-table-column>

      <template #empty>
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
          </div>
        </section>
      </template>
    </b-table>
  </section>
</template>

<script>
import debounce from 'lodash/debounce'
import { AREA_API, TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'TravelGroupsDeleteList',

  data() {
    const { query } = this.$route
    let startDate = null
    let endDate = null
    let selectedDates = []

    if (query.start && query.end) {
      startDate = this.$dayjs.unix(query.start).toDate()
      endDate = this.$dayjs.unix(query.end).toDate()
      selectedDates = [startDate, endDate]
    }

    return {
      loadingGroups: false,
      total: 0,
      items: [],

      sending: false,
      selectedItems: [],

      filterStatus: query.status || '',
      searchCode: query.code || '',
      searchName: query.search || '',
      sortField: query.sort || 'code',
      sortOrder: query.order || 'asc',
      defaultSortOrder: 'asc',
      page: query.page || 1,
      perPage: query.page_size || 10,
      showExpired: query.exp || false,
      isHome: query.is_home || '',

      loadingAreas: false,
      areas: [],
      catalogs: [],
      selectedArea: null,
      selectedAreaCode: query.ac || null,
      selectedCatalog: null,
      selectedCatalogNo: query.cn || null,

      selectedDates,
      startDate,
      endDate
    }
  },
  computed: {
    isLoading() {
      return this.loadingGroups || this.loadingAreas
    }
  },
  mounted() {
    this.loadAreas()
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.getQuery(to.query)
      this.loadTravelGroups()
    }

    next()
  },
  methods: {
    async loadAreas() {
      try {
        this.loadingAreas = true
        const res = await this.axios.get(AREA_API)
        const areas = res.data.data
        this.areas = areas.sort(a => a.sort)
        this.catalogs = []
        this.selectedArea = null
        this.selectedCatalog = null

        if (this.selectedAreaCode) {
          this.selectedArea = areas.find(a => a.code === this.selectedAreaCode)
          this.catalogs = this.selectedArea
            ? this.selectedArea.catalogs.sort(c => c.sort)
            : []
        }
        if (this.selectedCatalogNo) {
          this.selectedCatalog = this.catalogs.find(
            c => c.catalog_no === this.selectedCatalogNo
          )
        }

        await this.loadTravelGroups()
      } catch (e) {
        this.areas = []
        this.catalogs = []
        this.selectedArea = null
        this.selectedAreaCode = null
        this.selectedCatalog = null
        this.selectedCatalogNo = null

        notifyService.fetch_error('area', e)
      } finally {
        this.loadingAreas = false
      }
    },
    async loadTravelGroups() {
      const api = TRAVEL_GROUPS_API

      const params = {
        is_collaborate: false,
        area_code: this.selectedAreaCode,
        catalog_no: this.selectedCatalogNo,
        active: this.filterStatus && this.filterStatus === 'true',
        start_date: this.startDate,
        end_date: this.endDate,
        show_expired: this.showExpired,
        is_home: this.isHome,
        search_code: this.searchCode,
        search: this.searchName,
        sort_by: this.sortField,
        by_descending: this.sortOrder !== 'asc',
        page_size: this.perPage,
        page_number: this.page
      }

      this.loadingGroups = true
      try {
        const res = await this.axios.get(api, { params })
        const data = res.data.data

        this.items = data.items
        this.total = data.item_count
      } catch (e) {
        this.items = []
        this.total = 0

        notifyService.fetch_error('travel_group', e)
      } finally {
        this.loadingGroups = false
      }
    },
    getQuery(query) {
      this.filterStatus = query.status || ''
      this.searchCode = query.code || ''
      this.searchName = query.search || ''
      this.sortField = query.sort || 'code'
      this.sortOrder = query.order || 'asc'
      this.page = query.page || 1
      this.perPage = query.page_size || 10
      this.showExpired = query.exp || false
      this.isHome = query.is_home || ''

      if (query.start && query.end) {
        this.startDate = this.$dayjs.unix(query.start).toDate()
        this.endDate = this.$dayjs.unix(query.end).toDate()
        this.selectedDates = [this.startDate, this.endDate]
      } else {
        this.startDate = null
        this.endDate = null
        this.selectedDates = []
      }

      this.selectedArea = null
      this.selectedCatalog = null
      this.selectedAreaCode = query.ac || null
      this.selectedCatalogNo = query.cn || null

      if (this.selectedAreaCode) {
        this.selectedArea = this.areas.find(
          a => a.code === this.selectedAreaCode
        )
        this.catalogs = this.selectedArea
          ? this.selectedArea.catalogs.sort(c => c.sort)
          : []
      }
      if (this.selectedCatalogNo) {
        this.selectedCatalog = this.catalogs.find(
          c => c.catalog_no === this.selectedCatalogNo
        )
      }
    },
    updateQuery() {
      const query = {
        status: this.filterStatus,
        exp: this.showExpired,
        ac: this.selectedAreaCode,
        cn: this.selectedCatalogNo,
        code: this.searchCode,
        search: this.searchName,
        sort: this.sortField,
        order: this.sortOrder,
        is_home: this.isHome,
        page_size: this.perPage.toString(),
        page: this.page.toString(),
        start: this.startDate && this.$dayjs(this.startDate).unix(),
        end: this.endDate && this.$dayjs(this.endDate).unix()
      }

      Object.keys(query).forEach(key => !query[key] && delete query[key])

      this.$router
        .push({
          name: this.$route.name,
          query: query
        })
        .catch(() => {})
    },

    onFilterStatus() {
      this.updateQuery()
    },
    onSelectArea(option) {
      this.selectedArea = option
      this.selectedAreaCode = option ? option.code : null
      this.catalogs = option ? option.catalogs.sort(c => c.sort) : []
      this.selectedCatalog = null
      this.selectedCatalogNo = null

      this.updateQuery()
    },
    onSelectCatalog(option) {
      this.selectedCatalog = option
      this.selectedCatalogNo = option ? option.catalog_no : null

      this.updateQuery()
    },
    onSelectedDates() {
      this.startDate = this.selectedDates[0]
      this.endDate = this.selectedDates[1]

      this.updateQuery()
    },
    onClearDates() {
      this.selectedDates = null
      this.startDate = null
      this.endDate = null

      this.updateQuery()
    },

    onFilter: debounce(function() {
      this.page = 1
      this.updateQuery()
    }, 500),
    onPageChange(page) {
      this.page = page
      this.updateQuery()
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order
      this.updateQuery()
    },

    onDelete(code) {
      this.$buefy.dialog.confirm({
        message: this.$t('attributes.confirm_delete'),
        onConfirm: () => {
          this.deleteGroup(code)
        }
      })
    },
    onDeleteMulti() {
      this.$buefy.dialog.confirm({
        message: this.$t('attributes.confirm_delete'),
        onConfirm: () => {
          const codes = this.selectedItems.map(g => g.code)
          this.deleteGroups(codes)
        }
      })
    },
    async deleteGroup(code) {
      const api = `${TRAVEL_GROUPS_API}/${code}`

      this.sending = true
      try {
        await this.axios.delete(api)

        notifyService.success(this.$t('attributes.delete_succeed'))
        this.selectedItems = []
        await this.loadTravelGroups()
      } catch (e) {
        notifyService.delete_error(e)
      } finally {
        this.sending = false
      }
    },
    async deleteGroups(codes) {
      const api = `${TRAVEL_GROUPS_API}/delete-groups`

      this.sending = true
      try {
        await this.axios.delete(api, {
          headers: { 'Content-Type': 'application/json' },
          data: codes
        })

        notifyService.success(this.$t('attributes.delete_succeed'))
        this.selectedItems = []
        await this.loadTravelGroups()
      } catch (e) {
        notifyService.delete_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.b-table {
  margin-top: 0.75rem;
}

.datepicker {
  .datepicker-table {
    .datepicker-cell {
      padding: 0.6rem 0.65rem;
    }
  }
}
</style>
